// Factories
import { BaseStoreLoader } from "../../base/loaders/BaseStoreLoader";
/**
 * Loader class for store providers in Teams app
 */
export class MetaOSAppStoreLoader extends BaseStoreLoader {
}
